import http from './ApiConfig';
import { Service } from './Service';

/**
 * Servico da fundacao de comunicacao ativa com o paciente (Onda4).
 * Backend: api/comunicacao — historico de envios WhatsApp, consentimento
 * (opt-out LGPD art. 18, V) e envio de teste do canal da clinica.
 */
export class ComunicacaoService extends Service {
  constructor() {
    super('api/comunicacao');
  }

  /** Historico paginado das comunicacoes enviadas a um paciente. */
  public ObterHistorico(pacienteId: number, page = 1, pageSize = 10): Promise<any> {
    return http.get(
      `${this._nomeControle}/historico?pacienteId=${pacienteId}&page=${page}&pageSize=${pageSize}`,
      this.GetHeader(),
    );
  }

  /** Registra opt-out/opt-in de comunicacao WhatsApp do paciente (LGPD). */
  public RegistrarOptOut(pacienteId: number, aceita: boolean): Promise<any> {
    return http.post(
      `${this._nomeControle}/paciente/${pacienteId}/opt-out`,
      { aceita },
      this.GetHeader(),
    );
  }

  /** Dispara uma mensagem de teste do canal WhatsApp para o paciente. */
  public EnviarTeste(pacienteId: number): Promise<any> {
    return http.post(`${this._nomeControle}/teste/${pacienteId}`, null, this.GetHeader());
  }
}

export default ComunicacaoService;
